export default __webpack_public_path__ + "b69df4b1c5a459020a1c4c5ff42e0537.svg";